// extracted by mini-css-extract-plugin
module.exports = {"heroBg":"#fc0","bpMobile":"screen and (max-width: 675px)"};